import React from "react";

const Attribution = () => {
  return (
    <div class="attribution">
      Challenge by &nbsp;
      <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">
        Frontend Mentor
      </a>
      . Coded by &nbsp;
      <a
        href="https://github.com/oludamilola-m"
        rel="noopener noreferrer"
        target="_blank"
      >
        Osiname Oludamilola
      </a>
    </div>
  );
};

export default Attribution;
